import React, { useState } from 'react';
import styled from 'styled-components';
import Window from '../Window';
import { 
  FolderOpen, 
  FileText, 
  Github, 
  ExternalLink,
  File,
  Image,
  Globe
} from 'lucide-react';

const TrashContainer = styled.div`
  display: flex;
  height: 100%;
  background: #f8f9fa;
`;

const Sidebar = styled.div`
  width: 200px;
  background: #e9ecef;
  border-right: 1px solid #dee2e6;
  padding: 16px;
`;

const SidebarSection = styled.div`
  margin-bottom: 20px;
`;

const SidebarTitle = styled.h4`
  margin: 0 0 12px 0;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const SidebarItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 4px;
  font-size: 13px;
  
  &:hover {
    background: #dee2e6;
  }
  
  &.active {
    background: #007AFF;
    color: white;
  }
`;

const MainContent = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

const ContentHeader = styled.div`
  margin-bottom: 20px;
`;

const ContentTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #333;
`;

const ContentSubtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  font-style: italic;
`;

const FileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 20px;
`;

const FileItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 122, 255, 0.1);
  }
`;

const FileIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: ${props => props.color || '#666'};
  margin-bottom: 8px;
`;

const FileName = styled.div`
  text-align: center;
  font-size: 12px;
  color: #333;
  max-width: 100px;
  word-wrap: break-word;
  line-height: 1.2;
`;

const TrashApp = ({ ...windowProps }) => {
  const [selectedItem, setSelectedItem] = useState('trash');

  const sidebarItems = [
    {
      title: 'Section Header',
      items: [
        { name: 'Work', icon: <FolderOpen size={16} />, id: 'work' },
        { name: 'About Me', icon: <FolderOpen size={16} />, id: 'about' },
        { name: 'Resume', icon: <FileText size={16} />, id: 'resume' },
        { name: 'Trash', icon: <FolderOpen size={16} />, id: 'trash', active: true }
      ]
    },
    {
      title: 'Section Header',
      items: [
        { name: 'Project 01', icon: <FolderOpen size={16} />, id: 'project1' },
        { name: 'Project 02', icon: <FolderOpen size={16} />, id: 'project2' },
        { name: 'Project 03', icon: <FolderOpen size={16} />, id: 'project3' },
        { name: 'Project 04', icon: <FolderOpen size={16} />, id: 'project4' }
      ]
    }
  ];

  const trashFiles = [
    {
      name: "World Domination Plan.txt",
      icon: <File size={32} />,
      color: "#FF6B6B"
    },
    {
      name: "breakdown.img",
      icon: <Image size={32} />,
      color: "#4ECDC4"
    },
    {
      name: "sorry_no thanks.pdf",
      icon: <FileText size={32} />,
      color: "#FF3B30"
    },
    {
      name: "portfolio_2024.com",
      icon: <Globe size={32} />,
      color: "#007AFF"
    }
  ];

  return (
    <Window {...windowProps} size={{ width: 800, height: 500 }}>
      <TrashContainer>
        <Sidebar>
          {sidebarItems.map((section, index) => (
            <SidebarSection key={index}>
              <SidebarTitle>{section.title}</SidebarTitle>
              {section.items.map((item, itemIndex) => (
                <SidebarItem
                  key={itemIndex}
                  className={item.active ? 'active' : ''}
                  onClick={() => setSelectedItem(item.id)}
                >
                  {item.icon}
                  {item.name}
                </SidebarItem>
              ))}
            </SidebarSection>
          ))}
        </Sidebar>
        
        <MainContent>
          <ContentHeader>
            <ContentTitle>Trash</ContentTitle>
            <ContentSubtitle>I said, don't look!</ContentSubtitle>
          </ContentHeader>
          
          <FileGrid>
            {trashFiles.map((file, index) => (
              <FileItem key={index}>
                <FileIcon color={file.color}>
                  {file.icon}
                </FileIcon>
                <FileName>{file.name}</FileName>
              </FileItem>
            ))}
          </FileGrid>
        </MainContent>
      </TrashContainer>
    </Window>
  );
};

export default TrashApp;
